<template>
  <Head title="Insights - Generate Presentation" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <generate-presentation 
            :report_pages="report_pages" 
            :client="client"  
            :exports="exports"
          ></generate-presentation>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  report_pages: Array,
  client: Object,
  exports: Array
});
</script>

